import React from 'react';
import './About.css';
// import aboutImage from '../images/cabs.jpg';

const About = () => {
  return (
    <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h3 className="about-subtitle">GV Travels Madurai</h3>
            <h2 className="about-title">About</h2>
            <p className="text-center about-para">இப்பொழுது மதுரை மாநகரில் 24 மணி நேர உள்ளூர் மற்றும் வெளியூர் பயணங்களுக்கு துரித சேவையில் மிக குறைந்த வாடகையில் எங்கள் சேவையினை வழங்கி வருகிறோம் .
              வாருங்கள்! ஆதரவு தாருங்கள்! வளர்கிறோம்!
              உங்கள் பாதுகாப்பான வெற்றி பயணங்களில் தோழனாய் எங்களையும் இணைத்து கொள்ளுங்கள்.</p>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="about-image">
                  <img src="../images/About-image.png" alt="GV Travels Madurai Office" className="img-fluid" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="about-content">
                  <p>
                    <strong>GV Travels</strong> is one of the leading cab service providers in Madurai. We offer the best rides at affordable prices without compromising on quality. As the best cab booking service in Madurai, we have experienced drivers who are well-versed in all major routes and destinations.
                  </p>
                  <p>
                    All Types of trips <strong>Local Sightseeing Places, Cabs Services, Outstation, as well as Pickup & Drop services—are available.</strong> We are planning to focus on a customer-centric approach and gain recognition among worldwide clients. Call Taxi booking in Madurai service is all that you need if you are looking for a ride. We provide special care to our customers as they have very limited time to spare. Have the luxury of making your own tour packages according to your preferences.
                  </p>
                  <p>
                    <strong>GV Travels</strong> has a wide range of package options, including cab booking, Madurai cabs service, cabs service in Madurai, luxury cabs service Madurai, affordable cabs service Madurai, corporate cabs service Madurai, business trips cabs service Madurai, best cab booking in Madurai, taxis/cabs in Madurai, business tours in Madurai, and more.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default About;
